@if (dados) {
  <div class="footer-card">
    <div class="container-select">
      <app-select
        (change)="alterarTamanho.emit()"
        [value]="tamanho"
        (valueChanges)="tamanhoChange.emit($event)"
        name="tamanhoName"
        [options]="opcoesExibicao"
        optionValue="value"
        optionText="name"
        [tag]="tagDropdown">
      </app-select>
    </div>
    <div class="py-0 px-2">
      @for (item of itensPaginacao; track item) {
        <button
          class="itens-pagina btn-icon"
          [ngClass]="{ 'item-ativo': pagina == item.valor }"
          (click)="alterarPagina.emit(item.valor)"
          (keydown.enter)="alterarPagina.emit(item.valor)"
        [tag]="tagPagina">{{ item.pagina }}</button>
      }
    </div>
    <div class="container-registros">
      <p><span class="itens-pagina me-0">{{dados.pageRequest.total}}</span> Registros foram encontrados</p>
    </div>
  </div>
}
